import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import DeliverableList from "@/components/lists/deliverable.vue"
  import DeliverableToolbar from "@/components/toolbars/deliverable.vue"
  import {nextTick, onBeforeMount, PropType, ref} from "vue"
  import {
    Deliverable,
    DeliverableEnumerationResponse,
    DeliverableInput,
    DeliverableResponse
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import Paginator from "@/components/paginator.vue"
  import {Deliverable as DeliverableClient} from "@/endpoints/rutsolve/gql/resolvers/deliverable"
  import {Enumeration as EnumerationClient} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import {DeliverableSelector as Storage} from "@/storage/deliverable_selector"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'deliverable',
  props: {
    "value": {
    default: null,
    required: false,
    type: Object as PropType<Deliverable>
  },
    "valueModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels([
    "select",
  ], ["update:value"]),
  setup(__props, { emit: __emit }) {

  const value = _useModel(__props, "value")

  const emits = __emit

  const error = ref<Error>(null)
  const deliverableClient = new DeliverableClient()
  const enumerationClient = new EnumerationClient()
  const deliverableResponse = ref<DeliverableResponse>(null)
  const deliverableEnumerationResponse = ref<DeliverableEnumerationResponse>(null)
  const deliverableInput = ref<DeliverableInput>(null)
  const selectedIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  function update() {
    Storage.writeDeliverableInput(deliverableInput.value)
    read()
  }

  async function select() {
    const selectedDeliverable = deliverableResponse.value.records[selectedIndex.value]
    value.value = selectedDeliverable
    Storage.writeSelectedDeliverableID(selectedDeliverable.id)
    await nextTick()
    emits("select")
  }

  function reset() {
    Storage.deleteDeliverableInput()
    Storage.deleteSelectedDeliverableID()
    selectedIndex.value = null
    value.value = null
    read()
  }

  async function read() {
    try {
      deliverableEnumerationResponse.value = await enumerationClient.readDeliverableEnumerations()
      const storedDeliverableInput = Storage.readDeliverableInput()
      deliverableInput.value = structuredClone(storedDeliverableInput)
      deliverableResponse.value = await deliverableClient.selector(storedDeliverableInput)
      if (!deliverableResponse.value || !deliverableResponse.value.records) {
        return
      }
      const storedSelectedDeliverableID = Storage.readSelectedDeliverableID()
      for (const [index, deliverable] of deliverableResponse.value.records.entries()) {
        if (deliverable.id == storedSelectedDeliverableID) {
          selectedIndex.value = index
          value.value = deliverable
          break
        }
      }
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (deliverableEnumerationResponse.value)
        ? (_openBlock(), _createBlock(DeliverableToolbar, {
            key: 0,
            value: deliverableInput.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((deliverableInput).value = $event)),
            deliverableOrders: deliverableEnumerationResponse.value.orders,
            deliverableTypes: deliverableEnumerationResponse.value.types,
            onUpdate: _cache[1] || (_cache[1] = ($event: any) => (update())),
            onReset: _cache[2] || (_cache[2] = ($event: any) => (reset()))
          }, null, 8, ["value", "deliverableOrders", "deliverableTypes"]))
        : _createCommentVNode("", true),
      (deliverableResponse.value)
        ? (_openBlock(), _createBlock(DeliverableList, {
            key: 1,
            selectedIndex: selectedIndex.value,
            "onUpdate:selectedIndex": _cache[3] || (_cache[3] = ($event: any) => ((selectedIndex).value = $event)),
            items: deliverableResponse.value.records,
            onSelect: _cache[4] || (_cache[4] = ($event: any) => (select()))
          }, null, 8, ["selectedIndex", "items"]))
        : _createCommentVNode("", true),
      (deliverableResponse.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 2,
            currentPage: deliverableInput.value.plot.page,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((deliverableInput.value.plot.page) = $event)),
            itemTotal: deliverableResponse.value.recordsTotal,
            pageItems: deliverableInput.value.plot.items,
            onUpdate: _cache[6] || (_cache[6] = ($event: any) => (update()))
          }, null, 8, ["currentPage", "itemTotal", "pageItems"]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 3,
            error: error.value,
            "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})